export class Rectangle {
  x?: number;
  y?: number;
  width?: number;
  height?: number;
}
